/**
 * 服务端预取数据Context
 *
 * 用于在组件树中传递服务端预取的数据
 */

import { PrefetchData } from '@/types/serverSideProps';
import { createContext, useContext } from 'react';

interface PrefetchDataContextValue {
  prefetchData?: PrefetchData;
}

const PrefetchDataContext = createContext<PrefetchDataContextValue>({});

/**
 * 获取服务端预取数据
 * @returns 服务端预取数据
 *
 * @example
 * ```tsx
 * const { prefetchData } = usePrefetchData();
 * console.log(prefetchData?.location);
 * ```
 */
export function usePrefetchData() {
  return useContext(PrefetchDataContext);
}

/**
 * 服务端预取数据Provider
 * 在App.tsx中使用,将服务端预取数据传递给子组件
 */
export const PrefetchDataProvider = PrefetchDataContext.Provider;
